import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Data Marketing"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "Daftar Marketing")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Marketing = _resolveComponent("Marketing", true)!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _hoisted_1,
    _createVNode(_component_Marketing)
  ], 2))
}